import { createRouter, createWebHistory } from "vue-router";
import { useStoreSite } from "@/stores/store.site";
import { useGtm } from '@gtm-support/vue-gtm';
import Utils from "./helpers/Utils";

const routes = [
  {
    path: "/payment",
    name: "payment",
    component: () => import("@/views/Form.Payment.vue"),
    meta: { layout: "blank" },
    children: [
      {
        path: "success",
        name: "payment-success",
        component: () => import("@/views/Site.PaymentSuccess.vue"),
      },
    ],
  },
  {
    path: "/payment/success",
    name: "payment-success",
    component: () => import("@/views/Site.PaymentSuccess.vue"),
  },
  {
    path: "/system-error/:errorType",
    name: "system-error",
    props: { errorType: null },
    component: () => import("@/views/Site.Error.vue"),
    meta: { layout: "blank" },
  },
  {
    path: "/:catchAll(.*)*",
    name: "bad-not-found",
    props: true,
    component: () => import("@/views/Site.NotFound.vue"),
    meta: { layout: "blank" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      const pos = savedPosition || to.meta?.scrollPos || { top: 0, left: 0 };
      setTimeout(() => {
        resolve(pos);
      }, 200);
    });
  },
});

router.afterEach(async (to, from) => {
    
  if (to.meta.layout) {
    const storeSite = useStoreSite();
    storeSite.setLayout(to.meta.layout);
  }
  const gtm = useGtm();
  if (to.path) {
    gtm.trackEvent({
      event: 'content-view',
      pageTitle: to.path === "/" ? "Central - Landing" : `Central - ${Utils.formatPath(to.path)}`,
      pageUrl: window.location.href
    })
  }
});


router.beforeEach(async (to, from, next) => {
  const storeSite = useStoreSite();

  const init = storeSite.init;
  if (!init) {
    storeSite.initialise();
  } 

  next();
});

export default router;